<template>
    <div :class="[{ 'is-active': isActive }, 'modal']">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    MBK
                </p>
                <button class="delete" aria-label="close" @click="close();"></button>
            </header>
            <section class="modal-card-body">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">{{ "components.common.mbk.modal.code" | translate }}</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control">
                                <input v-model="code" class="input" ref="code" />
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot buttons is-right">
                <button class="button is-success" @click="save();">{{ "components.common.mbk.modal.save" | translate }}</button>
                <button class="button" @click="close();">{{ "components.common.mbk.modal.cancel" | translate }}</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import localDataService from "../../../../../_common/services/localdata.service";

    const localDataKey = "code";
    const keyboardKeyCode = 77;

    export default {
        name: "modal-mbk",
        data: () => ({ isActive: false, code: null, inputElement: null }),
        watch: {
            isActive: function(value) {
                if (value) {
                    this.code = localDataService.get(localDataKey);
                    setTimeout(() => {
                        this.inputElement.focus();
                        this.inputElement.setSelectionRange(0, this.inputElement.value.length)
                    });
                }
                else {
                    this.code = null;
                }
            }
        },
        mounted() {
            this.inputElement = this.$refs.code;
            document.addEventListener("keyup", event => event.ctrlKey && event.keyCode === keyboardKeyCode && this.toggle());
        },
        methods: {
            open() {
                this.isActive = true;
            },
            close() {
                this.isActive = false;
            },
            toggle() {
                this.isActive = !this.isActive
            },
            save() {
                const code = localDataService.get(localDataKey);
                localDataService.set(localDataKey, this.code);
                this.close();
                this.code != code && location.reload();
            }
        }
    };
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/mbk/modal.vue